import View            from '@widesk-ui/components/View';
import Button          from '@widesk-ui/components/Button';
import useDesignTokens from '@/hooks/useDesignTokens';

/** Remplace l'adresse d'une image importée sur notre stockage, qui ne parle à personne. */
export default function ImportedImageBox({ onReplace, onRemove }: {
	onReplace: () => void;
	onRemove: () => void;
}) {
	const tokens = useDesignTokens();

	return (
		<View
			row
			centerV
			gap="sm"
			h={40}
			br={8}
			bg={tokens.surface.elevated}
			style={{ padding: '0 6px 0 11px', border: `1px solid ${tokens.border.default}` }}
		>
			<View flex size={14}>Image importée</View>

			<Button type="link" size="small" onClick={onReplace}>
				Remplacer
			</Button>

			<Button type="text" size="small" style={{ color: tokens.text.muted }} onClick={onRemove}>
				Retirer
			</Button>
		</View>
	);
}
